import {
  contains,
  delete_duplicates,
  filter,
  group_by,
  length,
  map,
  merge,
  object_map,
  to_array,
} from "@pdfking/rfunc"
import { Identity, KeyDrop, Keys, SortBy } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import virtual from "@pdfking/workflow/vue/3/virtual"
import { toRaw } from "vue"
import CreateStorage from "../files/providers/create"
import { DefaultBackend } from "../files/storage/DefaultBackend"
import persistence from "../utils/persistence"

const store = persistence("storage")

const backend = virtual({
  computed: {
    all_files_checked: {
      get() {
        // @ts-expect-error TS2339
        const s = length(this.selected_files)
        // @ts-expect-error TS2339
        const t = length(this.files)
        return s == t && t > 0
      },
      set(v) {
        // @ts-expect-error TS2339
        this.unselected_files_names = v ? [] : Keys(this.files)
      },
    },
    files() {
      // @ts-expect-error TS2339
      return this.provider?.files || {}
    },
    files_by_id() {
      return group_by(this.files, f => f.id)
    },
    selected_files() {
      // @ts-expect-error TS2551
      return KeyDrop(this.files, this.unselected_files_names)
    },

    selected_files_names: {
      get() {
        // @ts-expect-error TS2339
        return SortBy(Keys(this.selected_files))
      },
      set(v) {
        // @ts-expect-error TS2339
        this.unselected_files_names = Keys(KeyDrop(this.files, v))
      },
    },
  },
  data: () => ({
    config: {},
    last_session: null,
    provider: {},
    unselected_files_names: [],
  }),
  methods: merge(
    object_map(
      Identity,
      k =>
        function (...input) {
          //console.info("running backend", k, input)
          const callback =
            // @ts-expect-error TS2683
            this.provider[k] ||
            (async (...args) => console.info("unhandled", k, ...args))
          return Promise.resolve(callback(...input)).catch(error =>
            // @ts-expect-error TS2345
            fire_event(document, "tracked_error", error)
          )
        },
      [
        "open_files",
        "open_folders",
        "add_files",
        "remove_files",
        "refresh",
        "cleanup",
      ]
    ),
    {
      select_files(files) {
        // @ts-expect-error - Vue data prop
        this.selected_files_names = delete_duplicates(
          to_array(
            // @ts-expect-error - Vue data prop
            this.selected_files_names,
            map(f => f.id, to_array(files))
          )
        )
        return files
      },
      set_config(spec, no_store = false) {
        const config = toRaw(spec || DefaultBackend)
        CreateStorage(config).then(provider => {
          // @ts-expect-error - Vue data prop
          this.config = config
          // @ts-expect-error - Vue data prop
          this.provider = provider
          if (!no_store) store.set(config)
          provider.populate()
        })
      },
      unselect_files(files) {
        // @ts-expect-error - Vue data prop
        this.selected_files_names = filter(
          k => !contains(files, k),
          // @ts-expect-error - Vue data prop
          this.selected_files_names
        )
        return files
      },
    }
  ),
  mounted() {
    store.get().then(config => this.set_config(config, true))
  },
})

export default backend
